import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBackward,
  faChevronLeft,
  faChevronRight,
  faForward,
  faList,
  faMusic,
  faPause,
  faPlay,
  faQuoteLeft,
  faVolumeUp,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebookF } from "@fortawesome/fontawesome-free-brands";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Meta from "vue-meta";
import VueMq from "vue-mq";
import { VueMasonryPlugin } from "vue-masonry";
import vueSmoothScroll from "vue2-smooth-scroll";
import VueResource from "vue-resource";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

library.add(faQuoteLeft);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faPlay);
library.add(faPause);
library.add(faForward);
library.add(faBackward);
library.add(faList);
library.add(faFacebookF);
library.add(faVolumeUp);
library.add(faMusic);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;

Vue.use(Meta);
Vue.use(VueScrollTo);
Vue.use(VueMq, {
  breakpoints: {
    tn: 479,
    sm: 767,
    md: 991,
    lg: Infinity,
  },
});
Vue.use(VueMasonryPlugin);
Vue.use(vueSmoothScroll);
Vue.use(VueResource);
Vue.http.options.root = process.env.VUE_APP_BASE_URL;
Vue.http.interceptors.push(function (request, next) {
  request.params["locale"] = this.$route.params.locale || "ro";
  next();
});

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAxCUMePgxjsTrUl8pJjx4Our9tXZSRUp4",
  },
});

import router from "./router";
import App from "./App";

import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import { translations } from "./translations";

const i18n = new VueI18n({
  messages: translations,
  locale: "ro",
  // fallbackLocale: "ro"
});

import CountryFlag from "vue-country-flag";

Vue.component("country-flag", CountryFlag);
router.beforeEach((to, from, next) => {
  let locale = "",
    localeUrlSegment = to.path.split("/"),
    currentLocale = i18n.locale;

  // Get locale from path
  localeUrlSegment.shift();
  locale = localeUrlSegment[0];

  // Locale fallback
  if (locale === "") locale = currentLocale;

  // Set locale
  i18n.locale = locale;
  to.params.locale = locale;

  // Move on the next hook (render component view)
  next();
});
import store from "./store";
new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
